<template src="./footer-app.html"></template>
<style lang="less" scoped src="./footer-app.less"></style>

<script>
    export default {
        props: {
            nomeDaLoja: String
        }
    }
</script>